import Ajax from '@utils/ajax';

export default {
  get(options = {}) {
    return Ajax.get({
      url: `/bookmark_collections`,
      ...options,
    });
  },

  create(data, options = {}) {
    return Ajax.post({
      url: `/bookmark_collections`,
      data: data,
      ...options,
    });
  },

  update(collection, data, options = {}) {
    return Ajax.post({
      url: `/bookmark_collections/${collection.id}`,
      data: { bookmark_collections: data, _method: 'PATCH' },
      ...options,
    });
  },

  addBookmarkToCollection(collectionId, bookmarkId, options = {}) {
    return Ajax.post({
      url: `/bookmark_collections/${collectionId}/add_bookmark_to_collection`,
      data: { bookmark_id: bookmarkId },
      ...options,
    });
  },

  removeBookmarkFromCollection(collectionId, bookmarkId, options = {}) {
    return Ajax.post({
      url: `/bookmark_collections/${collectionId}/remove_bookmark_from_collection`,
      data: { bookmark_id: bookmarkId },
      ...options,
    });
  },

  destroy(collection, undo = false, options = {}) {
    let data = { _method: 'DELETE' };
    if (undo) {
      data['undo'] = 1;
    }
    return Ajax.post({
      url: `/bookmark_collections/${collection.id}`,
      data: data,
      ...options,
    });
  },
};
